<template>
  <div class="container-login-principal">
       <LoadCircle
      :exibirLoad="realizandoRequisicao"
      sizeCircle="100px"
      pwidth="100%"
      pheight="92%"
    />
    <div class="container-component-login">
      <img src="../assets/logo-soluções-color.png" alt="logo da kurier consult" />
      <a-form :layout="formLayout">
        <h3 style="text-align: center; margin-bottom:0px; margin-top: 20px">Nova Senha</h3>
        <div class="login">
          <a-form-item
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          ></a-form-item>

          <div class="login-label">
            <label>Senha:</label>
          </div>
          <a-form-item
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <div>
              <img
                    @click="mostrarSenha = !mostrarSenha"
                    class="login-olho-senha"
                    src="../assets/icons/visualizar.png"
                    alt="visualizar senha"
                />
            </div>
            <a-input
              v-model="senha"
              @click="[senhaValidado = true,senhasNaoConferem = true, qtdCaracteres = true]"
              :type="mostrarSenha ? 'text' : 'password'"
              :class="[!senhaValidado ? 'erroInput' : 'resetErroInput']"
            />
            <p style="color:red" v-if="!senhaValidado">
              Preencha o campo corretamente.
            </p>
          </a-form-item>
          <div class="login-grupo-label">
            <div class="login-label">
              <label>Repetir Senha</label>
            </div>
          </div>
          <a-form-item
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
          <div>
              <img
                @click="mostrarRepetirSenha = !mostrarRepetirSenha"
                class="login-olho-senha"
                src="../assets/icons/visualizar.png"
                alt="visualizar senha"
              />
            </div>
            <a-input
              :class="[!repetirSenhaValidado ? 'erroInput' : 'resetErroInput']"
              @click="repetirSenhaValidado = true"
              v-model="repetirSenha"
              :type="mostrarRepetirSenha ? 'text' : 'password'"
              placeholder
            />
            <p style="color:red" v-if="!repetirSenhaValidado">
              Preencha o campo corretamente.
            </p>
            <p style="color:red" v-if="!senhasNaoConferem">
              As senhas não conferem.
            </p>
            <p style="color:red" v-if="!qtdCaracteres">
              A senha deve conter no minimo 6 digitos.
            </p>
            <p></p>
          </a-form-item>

          <a-form-item :wrapper-col="buttonItemLayout.wrapperCol">
            <div class="btn-login">
              <a-button @click="autenticar">Alterar Senha</a-button>
            </div>
          </a-form-item>
        </div>
      </a-form>
    </div>
    <notifications
      classes="style-notification"
      group="general"
      position="bottom center"
      :ignoreDuplicates="true"
      animation-name="v-fade-left"
    />
  </div>
</template>

<script>
import usuarioApi from "../api/usuarioApi";
import LoadCircle from "../components/Load/LoadCircle.vue";
export default {
  name: "autenticacao",
  components: {LoadCircle},
  data() {
    return {
      formLayout: "vertical",
      mostrarSenha: false,
      mostrarRepetirSenha: false,
      senhaValidado: true,
      repetirSenhaValidado: true,
      senhasNaoConferem : true,
      qtdCaracteres: true,
      senha: "",
      repetirSenha: "",
      realizandoRequisicao: false
    };
  },
  computed: {
    formItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
          }
        : {};
    },
    buttonItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            wrapperCol: { span: 14, offset: 4 },
          }
        : {};
    },
    dataSetSelecionado() {
      let result = this.dataSettes.filter((item) => {
        return item.marcado == true;
      });
      return result;
    },
  },
  mounted() {
  },
  methods: {
    desmarcarItem(index) {
      this.dataSettes.map(function(item) {
        if (item.nome == index.nome) {
          item.marcado = false;
        }
      });
    }, 
    autenticar() {
      
       if (this.validar()) {
         this.realizandoRequisicao = true;
          let objectNovaSenha = {
            senha : this.senha
          }
          usuarioApi.alterarSenha(objectNovaSenha).then(
          (response) => {
            if (response.status == 200) {
              this.realizandoRequisicao = false
              this.$router.push({name: "selecaoTipoConsulta"});
            } else if (response.status == 404) {
              this.realizandoRequisicao = false
              this.$notify({
                group: "general",
                title: "Falha na conexão.",

                duration: 1000,

                speed: 700,
              });
              this.usuario = "";
              this.senha = "";
            }else if(response.status == 400){
              this.realizandoRequisicao = false
              if(response.data.error == "invalid_grant"){
                  this.$notify({
                group: "general",
                title: "Usuário ou senha inválido",

                duration: 1000,

                speed: 700,
              });
              }
            }
          },
          () => {
            this.$notify({
              group: "general",
              title: "Falha na conexão.",

              duration: 1000,

              speed: 700,
            });
          }
        );
//          if(this.usuario == 'admin' && this.senha == 'admin'){
// this.$router.push("/selecao");
//          }else{
//            this.$notify({
//                 group: "general",
//                 title: "Email ou senha inválidos.",

//                 duration: 1000,

//                 speed: 700,
//               });
//          }

       }
    },
    validar() {
      let validado = true;
      if (!this.senha) {
        this.senhaValidado = false;
        validado = false;
      }
      if (!this.repetirSenha) {
        this.repetirSenhaValidado = false;
        validado = false;
      }
      if(this.senha != this.repetirSenha){
        this.senhasNaoConferem = false;
        validado = false;
      }
      if(this.senha.length < 6){
        this.qtdCaracteres = false;
        validado = false;
      }
      return validado;
    },
  },
};
</script>
<style scoped>
body {
  background-color: #f5f5f5;
}
.container-login-principal {
  background-color: #f5f5f5;
  height: 100%;
  width: 100%;
  position: absolute;
}
img {
  margin: 0 auto;
  margin-top: 35px;
  width: 250px;
  display: inherit;
  margin-right: 80px
}
.container-component-login {
  margin: 174px auto auto auto;
  background-color: #ffffff;
  max-width: 373px;
}
.login {
  padding: 0px 20px 20px 20px;
}
.ant-form-item {
  margin-bottom: 0px;
}
/* .container-component-login .ant-input:focus {
  border-color: red;
}
.container-component-login .ant-input:hover {
  border-color: yellow;
} */
.ant-input {
  height: 32px;
  max-width: 340px;
}
.login-olho-senha {
  cursor: pointer;
  position: absolute;
  width: 20px;
  margin:0px;
  z-index: 1;
  right:10px;
  top:10px
}
.login-grupo-label {
  max-width: 340px;
  display: flex;
  justify-content: space-between;
}
.btn-login {
  max-width: 340px;
  margin-top: 5px;
  display: flex;
  justify-content: flex-end;
}
.ant-btn {
  height: 34px;
}
.btn-login > .ant-btn:active {
  background-color: #052f6b;
}
.btn-login > .ant-btn {
  background-color: #001a3f;
  color: #edf0f2;
}

.login-label {
  margin-bottom: 5px;
  color: #525252;
  margin-left: 0px;
  display: flex;
  justify-content: flex-start;
}
.login-esqueci-senha {
  display: flex;
  justify-content: flex-end;
  font-size: 0.8em;
}
.login-footer {
  margin: 0 auto auto auto;
  max-width: 400px;
  padding-left: 20px;
  font-size: 0.8em;
  display: flex;
  justify-content: flex-start;
}
.login-footer p {
  margin: 10px;
  color: #525252;
}
</style>
